import { useQuery } from '@tanstack/react-query';
import bookingApi from '@/features/public/booking/api/bookingApi.ts';
import { bookingApiQueryKeys } from '@/features/public/booking/api/bookingApi.queryKeys.ts';

export const getBookingInsurancesQueryOptions = (
  orgSlug: string,
  tourSlug: string,
) => ({
  queryKey: bookingApiQueryKeys.bookingInsurances(orgSlug, tourSlug),
  queryFn: () => bookingApi.getBookingInsurances(orgSlug, tourSlug),
});

const useGetBookingInsurances = (orgSlug: string, tourSlug: string) => {
  return useQuery(getBookingInsurancesQueryOptions(orgSlug, tourSlug));
};

export default useGetBookingInsurances;
